import React, { useMemo } from "react";
import { ENTITY_COLOR_UID_MAP } from "components/FormerEditor/common/constants/entity";
import { COLORS } from "utils/styles";
import classnames from "classnames";
import { getIconForUID } from "components/FormerEditor/utils";
import Tooltip from "components/Tooltip";
import { getUUID } from "utils/uuid";
const DIMENSIONS = 8;

const EntityHeader = ({
  uid,
  title,
  draggable,
  onClick,
  active,
  hover,
  compress
}) => {
  const Icon = getIconForUID(uid);
  const color = ENTITY_COLOR_UID_MAP[uid] || COLORS.primary;
  const compressTooltipId = useMemo(() => getUUID(), []);
  const tooltipId = useMemo(() => getUUID(), []);
  const showStatusDot = compress || active || hover;
  const iconContent = Icon && (
    <div
      style={{ height: 32, width: 32 }}
      className={classnames(
        "flex items-center justify-center bg-content--secondary br2 icon--boundary",
        {
          move: draggable
        }
      )}
    >
      <Icon size={18} color="#ffffff" />
      <style jsx>{`
        .icon--boundary {
          background-color: ${color};
        }
      `}</style>
    </div>
  );

  return (
    <div
      className={classnames(
        "flex items-center pb3 mb2 pointer justify-between",
        {
          "flex-row": !compress,
          "flex-column": compress
        }
      )}
      onClick={onClick}
    >
      <div className="flex flex-row items-center">
        {compress ? (
          <Tooltip id={compressTooltipId} tooltip={title}>
            {iconContent}
          </Tooltip>
        ) : (
          iconContent
        )}
        {!compress && <div className="pl2 f5 truncate fw5">{title}</div>}
      </div>
      {showStatusDot && (
        <Tooltip id={tooltipId} tooltip="Active">
          <div
            className={classnames("justify-end", {
              mt2: compress
            })}
            style={{
              width: DIMENSIONS,
              height: DIMENSIONS,
              borderRadius: "100%",
              backgroundColor: active ? COLORS.blue : COLORS.grip
            }}
          ></div>
        </Tooltip>
      )}
    </div>
  );
};

export default EntityHeader;
